module.exports = __webpack_public_path__ + "static/img/TT-1.4d645046.png";